import { render, staticRenderFns } from "./afs.vue?vue&type=template&id=7844bd1b"
import script from "./afs.vue?vue&type=script&lang=js"
export * from "./afs.vue?vue&type=script&lang=js"
import style0 from "./afs.vue?vue&type=style&index=0&id=7844bd1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports